enum QuestionStatusEnum {
	NEW = 'NEW',
	SUBMITTED = 'SUBMITTED',
	APPROVED = 'APPROVED',
	FAILED = 'FAILED',
	IRRELEVANT = 'IRRELEVANT'
}

export default QuestionStatusEnum;
